module.exports = "<ag-progress-list\n  [requestObject]=\"requestObject\"\n  [disableDetailFullScreen]=\"true\"\n  [job]=\"job\"\n></ag-progress-list>\n"